export { default } from './RedButton.js';
